var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepIco2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4286 23.0059C23.7964 23.0059 25.7143 21.1027 25.7143 18.7529C25.7143 16.4032 23.7964 14.5 21.4286 14.5C19.0607 14.5 17.1429 16.4032 17.1429 18.7529C17.1429 21.1027 19.0607 23.0059 21.4286 23.0059ZM20.3679 24.9906C16.85 24.9906 14 27.8188 14 31.3097C14 31.891 14.475 32.3623 15.0607 32.3623H24.0429C22.75 30.8525 22 28.9068 22 26.8477V25.7455C22 25.4868 22.0357 25.2316 22.1036 24.9906H20.3679ZM29.3321 31.5295L28.8571 31.7528V25.0863L32.2857 26.2204V26.915C32.2857 28.8927 31.1357 30.6895 29.3321 31.533V31.5295ZM28.4964 23.4134L24.4964 24.7354C24.0286 24.8913 23.7143 25.3237 23.7143 25.8128V26.915C23.7143 29.5519 25.25 31.9512 27.65 33.0712L28.3107 33.3795C28.4821 33.4575 28.6679 33.5 28.8536 33.5C29.0393 33.5 29.2286 33.4575 29.3964 33.3795L30.0571 33.0712C32.4643 31.9477 34 29.5483 34 26.9115V25.8093C34 25.3202 33.6857 24.8878 33.2179 24.7319L29.2179 23.4099C28.9821 23.3319 28.7286 23.3319 28.4964 23.4099V23.4134Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepIco2);
export default __webpack_public_path__ + "static/media/Step_ico_2.0dc1b8acb094a5d25c08de48761779f1.svg";
export { ForwardRef as ReactComponent };